/**
 * Manage the floating labels
 */
class FloatingLabels {
	static inputSelectors() {
		return [
			'input[type="text"]',
			'input[type="email"]',
			'input[type="password"]',
			'input[type="search"]',
			'input[type="url"]',
			'input[type="tel"]',
			'input[type="number"]',
			'textarea',
		].join(',')
	}

	constructor() {
		if (!FloatingLabels.instance) {
			// bind events
			this.handler = this.float.bind(this)
			this.updateLabels = this.evaluateInputs.bind(this)
			this.scrollToErrorInsideLayer = this.scrollToErrorInsideLayer.bind(this)
			this.scrollToErrorInsidePage = this.scrollToErrorInsidePage.bind(this)
			// start
			this.attachListeners()

			FloatingLabels.instance = this
		}

		return FloatingLabels.instance
	}

	/**
	 * Attach event listeners
	 */
	attachListeners() {
		yTos.watch({
			'yTos::EndAjaxRequest': this.updateLabels,
			'yTos::ScrollToError::InsideLayerInputNotOnScreen': this.scrollToErrorInsideLayer,
			'yTos::ScrollToError::InsidePageInputNotOnScreen': this.scrollToErrorInsidePage,
			'yTos::Checkout::VerificationNumberFieldLoaded': this.updateLabels,
			'CAR::UpdateFloatingLabel': this.updateLabels,
		})

		document.addEventListener('focus', this.handler, true)
		document.addEventListener('blur', this.handler, true)
	}

	/**
	 * Detach event listeners
	 */
	detachListeners() {
		yTos.unWatch({
			'yTos::EndAjaxRequest': this.updateLabels,
			'yTos::ScrollToError::InsideLayerInputNotOnScreen': this.scrollToErrorInsideLayer,
			'yTos::ScrollToError::InsidePageInputNotOnScreen': this.scrollToErrorInsidePage,
			'yTos::Checkout::VerificationNumberFieldLoaded': this.updateLabels,
			'CAR::UpdateFloatingLabel': this.updateLabels,
		})

		document.removeEventListener('focus', this.handler, true)
		document.removeEventListener('blur', this.handler, true)
	}

	scrollToErrorInsideLayer({ firstInputWithAnError }) {
		firstInputWithAnError[0].focus({ preventScroll: true })
		firstInputWithAnError[0].scrollIntoView({
			block: 'center',
			behavior: !yTos.Cartier.devices.prefersReduceMotion ? 'smooth' : 'auto',
		})
	}

	scrollToErrorInsidePage(firstInputWithAnError) {
		if (yTos.Cartier.isSafari()) {
			firstInputWithAnError[0].scrollIntoViewIfNeeded(true)
			return
		}

		firstInputWithAnError[0].focus({ preventScroll: true })
		firstInputWithAnError[0].scrollIntoView({
			block: 'center',
			behavior: !yTos.Cartier.devices.prefersReduceMotion ? 'smooth' : 'auto',
		})
	}

	evaluateInputs() {
		Array.prototype.slice
			.call(document.querySelectorAll(FloatingLabels.inputSelectors()))
			.forEach((input) => {
				const labelNode = document.querySelector(
					`label[for="${input.getAttribute('id')}"]`
				)?.parentElement
				if (labelNode && !labelNode.classList.contains('show'))
					labelNode.classList.add('show')
				this.updateLabelStatus(input, '')
			})
	}

	/**
	 * Calculate the entire event path.
	 *
	 * @param {Element} node
	 * @param {string} action
	 * @return {void}
	 */
	updateLabelStatus(node, action = '') {
		if (node.nodeType !== 1 || typeof node.value === 'undefined') {
			return
		}

		const inputId = node.getAttribute('id')
		const labelNode = document.querySelector(`label[for="${inputId}"]`)

		if (!labelNode) {
			return
		}

		labelNode.classList.remove('no-animate')
		if (node.value.length || action === 'focus' || node.hasAttribute('autocompleted')) {
			labelNode.classList.add('float')
		} else {
			labelNode.classList.remove('float')
		}

		if (action === '') {
			labelNode.classList.add('no-animate')
		}
	}

	/**
	 * Attach event listerns to initiate polyfill
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	float(e) {
		let running

		/**
		 * Request animation frame callback.
		 * Remove previously applied attributes.
		 * Add new attributes.
		 */
		const action = () => {
			running = false
			this.updateLabelStatus(e.target, e.type)
		}

		if (!running) {
			window.requestAnimationFrame(action)
			running = true
		}
	}
}

// TODO I think this class should be a singleton but the unit tests are exploding...
// const instance = new FloatingLabels()
// Object.freeze(instance)

export default FloatingLabels
